import { Operation } from '@/backend/models/operation';
import { Code } from '@/backend/models/code';
import { ParameterSubjectType, ParameterType } from '@/types/parameterTypes';
import { I18n } from '@/i18n/I18n';
import { OverlayTrigger, Placeholder, Tooltip } from 'react-bootstrap';
import { useTreeStore } from '@/frontend/store/TreeStore';
import { useProcedureInstanceStore } from '@/frontend/store/ProcedureInstanceStore';
import { ParameterTable } from '@/frontend/components/parameters/ParameterTable';
import { MonacoPythonEditor } from '../MonacoPythonEditor';
import { CodeOutput } from './CodeOutput';
import { LoadingSpinner } from '../LoadingSpinner';
import { Play } from '@/frontend/SVGs/Play';

export function CodeItem(props: { operation: Operation }) {
  const { operation } = props;
  const code = operation.code as Code;
  const { updateCode } = useTreeStore.getState();
  const { procedureInstance: procedure } = useProcedureInstanceStore((state) => state);

  const label = `${I18n.get('runItem', { itemType: I18n.get('operation') })} ${operation.title}`;

  return (
    <div>
      <ParameterTable subjectId={operation.id} parameterType={ParameterType.INPUT} subjectType={ParameterSubjectType.OPERATION} />
      <div className='py-3'>
        <MonacoPythonEditor script={code.script} onChange={(value) => void updateCode({ code: { ...code, script: value || '' } }, operation)} />
      </div>
      <ParameterTable subjectId={operation.id} parameterType={ParameterType.OUTPUT} subjectType={ParameterSubjectType.OPERATION} />
      {procedure?.isTemplate() && (
        <div className='py-3'>
          <OverlayTrigger
            placement="top"
            delay={{ show: 250, hide: 400 }}
            overlay={<Tooltip>{I18n.get('executeCodeTooltip')}</Tooltip>}
          >
            <div style={{ maxWidth: 'fit-content' }}><button
              aria-label={label}
              disabled={true}
              type='button'
              className='btn d-block btn-success'>
                <div className='d-flex align-items-center gap-2'>
                  {code.returnCode === 100 ? <LoadingSpinner /> : <Play />}
                  {I18n.get('executeCode')}
                </div>
            </button></div>
          </OverlayTrigger>
        </div>
      )}
      {code.lastRanAt && procedure?.isTemplate() && (
        <>
          <p className='mt-3'>{I18n.get('output')}</p>
          {code.stdout && (<code style={{whiteSpace: 'pre-wrap'}} className='d-block mb-3'>{I18n.get('stdout', {stdout: code.stdout})}</code>)}
          {code.stderr && (<code style={{whiteSpace: 'pre-wrap'}} className='d-block mb-3'>{I18n.get('stderr', {stderr: code.stderr})}</code>)}
          {code.returnCode !== 100 && (<code className='d-block'>{I18n.get('returnCode', {returnCode: code.returnCode.toString()})}</code>)}
          {code.returnCode === 100 && (
            <Placeholder animation='wave'>
              <Placeholder.Button className='btn btn-secondary' size='sm' xs={3} />
            </Placeholder>
          )}
          <div className='mt-3'>
            <CodeOutput operationId={operation.id} />
          </div>
        </>
      )}
    </div>
  );
}
